// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"654":"1389ebff","784":"d8c2a0d9"}[chunkId] + ".chunk.js";
};